export  const thememain = {
  colors: {
    primary: "bg-blue-600 hover:bg-blue-700 text-white",
    secondary: "bg-slate-100 hover:bg-slate-200 text-slate-700",
    danger: "bg-red-500 hover:bg-red-600 text-white",
    success: "bg-emerald-600 hover:bg-emerald-700 text-white",
    bluemain: "text-[#1a73e8]"
  },
  backgrounds: {
    main: "bg-slate-50",
    card: "bg-white border border-slate-200 shadow-sm",
  },
  text: {

    title: "text-slate-900 font-bold",
    subtitle: "text-slate-500 text-sm",
  }
};